import { render, staticRenderFns } from "./DkAutocomplete.vue?vue&type=template&id=21230994&scoped=true&"
import script from "./DkAutocomplete.vue?vue&type=script&lang=js&"
export * from "./DkAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./DkAutocomplete.vue?vue&type=style&index=0&id=21230994&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21230994",
  null
  
)

export default component.exports